import { useDispatch, useSelector } from 'react-redux';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';
import { Tab } from '@optimus-web/core';
import { getUrlParameter } from '@mews-commander/utils';
import { useTabContent } from '../modalManager/tabs';
import { SidebarContentProps } from '../../components/sidebar/createSidebar';
import { CommanderSidebar } from '../../components/sidebar';
import EntityTitle from '../../components/commander-ui/EntityTitle';
import { isDialogOpen } from '../dialog/selectors';
import { closeDialog } from '../dialog/reducer';
import { KnowledgeBase } from './knowledgeBase';
import { TicketForm, ExtendedTicketForm } from './ticketForm';
import { HELP_CENTER_SIDEBAR_NAME } from './module';
import { OPEN_SUPPORT_TICKET_URL_PARAM } from './constants';

enum HelpCenterTab {
    'KnowledgeBase' = 'knowledgeBase',
    'TicketForm' = 'ticketForm',
}

export const HelpCenterSidebar = () => {
    const opened = useSelector((state: ApplicationState) => isDialogOpen(state, { name: HELP_CENTER_SIDEBAR_NAME }));

    const dispatch = useDispatch();

    const isOpenSupportTicketUrlParam = getUrlParameter(OPEN_SUPPORT_TICKET_URL_PARAM) !== undefined;
    const onClose = () => dispatch(closeDialog(HELP_CENTER_SIDEBAR_NAME));
    const isExtendedTicketForm = useFeatureFlag(FeatureFlag.extendedTicketFormEnabled);

    const tabContentMap = {
        [HelpCenterTab.KnowledgeBase]: KnowledgeBase,
        [HelpCenterTab.TicketForm]: isExtendedTicketForm ? ExtendedTicketForm : TicketForm,
    };

    const { tabsConfig, tabContent } = useTabContent({
        initialTabValue: isOpenSupportTicketUrlParam ? HelpCenterTab.TicketForm : HelpCenterTab.KnowledgeBase,
        tabs: [
            <Tab
                key={HelpCenterTab.KnowledgeBase}
                id={HelpCenterTab.KnowledgeBase}
                label={<LocalizedText textKey={TextKey.SearchGuides} />}
                value={HelpCenterTab.KnowledgeBase}
            />,
            <Tab
                key={HelpCenterTab.TicketForm}
                id={HelpCenterTab.TicketForm}
                label={<LocalizedText textKey={TextKey.ContactUs} />}
                value={HelpCenterTab.TicketForm}
            />,
        ],
        tabContentMap,
    });

    const Sidebar = CommanderSidebar(tabContent as React.ComponentType<SidebarContentProps>);

    const sidebarProps = {
        fullScreen: true,
        opened,
        onClose,
        title: (
            <EntityTitle>
                <LocalizedText textKey={TextKey.HelpCenter} />
            </EntityTitle>
        ),
        tabsConfig,
        modal: true,
    };

    return <Sidebar {...sidebarProps} />;
};
